import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { SprocketIcon, EmailIcon, WebsiteIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EmbeddingInstructions = ({
  showIcons,
  canUseEmail = false,
  children
}) => {
  const marginBlockStart = showIcons ? '800' : '0';
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "embedding-instructions",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "baseline",
      marginBlockEnd: "100",
      children: [showIcons && /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(SprocketIcon, {
          size: "200",
          color: "icon-core-subtle"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: 'heading-50',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embeddingInstructions.hubspotPage.title"
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: marginBlockStart,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embeddingInstructions.hubspotPage.description"
      })
    }), canUseEmail && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "baseline",
        marginBlockEnd: "100",
        marginBlockStart: "500",
        children: [showIcons && /*#__PURE__*/_jsx(View, {
          marginInlineEnd: "300",
          children: /*#__PURE__*/_jsx(EmailIcon, {
            size: "200",
            color: "icon-core-subtle"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: 'heading-50',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "embeddingInstructions.hubspotEmail.title"
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: marginBlockStart,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embeddingInstructions.hubspotEmail.description"
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "baseline",
      marginBlockEnd: "100",
      marginBlockStart: "500",
      children: [showIcons && /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(WebsiteIcon, {
          size: "200",
          color: "icon-core-subtle"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: 'heading-50',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embeddingInstructions.externalPage.title"
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: marginBlockStart,
      children: children
    })]
  });
};
export default EmbeddingInstructions;